import WithAuthorizationRequired, { WithAuthorizationRequiredProps } from "./WithAuthorizationRequired";

import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";

interface PrivateRouteProps extends WithAuthorizationRequiredProps {
    component: React.ComponentType<any>;
    [key: string]: any;
}

const PrivateRoute: React.FC<PrivateRouteProps> = (props: PrivateRouteProps) => {
    const { component, claimCheck, allowIfHasRole, allowIfHasAnyRole, ...rest } = props;

    const Component = withAuthenticationRequired(
        WithAuthorizationRequired(component, {
            claimCheck,
            allowIfHasRole,
            allowIfHasAnyRole
        }),
        {
            onRedirecting: () => <p>Redirecting to authentication</p>
        }
    );
    return <Component {...rest} />;
};

export default PrivateRoute;
